import React, {useState} from 'react';
import TablaPersonalizada from 'components/TablaPersonalizada';
import TituloConIcono from 'components/tituloConIcono';
import {Card, CardContent, Grid} from '@mui/material';
import styles from 'styles/informacionDelCard';
import { functions } from 'constantes';
import TooltipPersonalizado from 'components/tooltip/TooltipPersonalizado';
import AgregarDisponibilidad from './AgregarDisponibilidad';
import { patchPersonalizadoConDosMetodos } from 'store/actions/customAction';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import ModalDeConfirmacion from 'components/Modales/ModalDeConfirmacion';
import { useDispatch } from 'react-redux';
import EditarValorDeLaTarifa from './EditarValorDeLaTarifa';
import { tipoDeMedio } from 'constantes/globalsStates';

let idDisponibilidad = null;
const DetalleDelTarifarioYDisponibilidad = ({datosGeneralesDelTarifario, tipoDelMedio, mostrarDetalleDelCanal}) => {
  const dispatch = useDispatch();
  const classes = styles(),
  [abrirModalAgregarDisponibilidad, setAbrirModalAgregarDisponibilidad ] = useState(false),
  [alertaDeConfirmacion, setAlertaDeConfirmacion] = useState(false),
  [datosDisponibilidad, setDatosDisponibilidad] = useState(""),
  [tarifarioDeMediosTelevisivos] = useState('tarifarioDeMediosTelevisivos'),
  [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', abrirAlerta: false, }),
  [cargandoSolicitud, setCargandoSolicitud] = useState(false),
  [editarTarifario, setEditarTarifario] = useState(false),
  [datosTarifario, setDatosTarifario] = useState("");
  const [tarifarioDeMediosRadiales] = useState('tarifarioDeMediosRadiales');
  const [tarifarioDeMediosEscritos] = useState('tarifarioDeMediosEscritos');

  const [encabezadoDisponibilidad] = useState([
    { title: 'Fecha de Inicio', field: 'fechaInicio', render: (rowData) => functions.FormatearFecha(rowData.fechaInicio || "")},
    { title: 'Fecha Fin', field: 'fechaFin', render: (rowData) => functions.FormatearFecha(rowData.fechaFin || "")},
    { title: 'Cantidad por dia', field: 'cantidadDisponiblePorDia'},
    { title: 'Acción', field: 'accion',
    render: rowData=><div style={{minWidth: '100px'}}>
        {
            (<div>
                <TooltipPersonalizado title="Eliminar disponibilidad" handleFunction={() => eliminarDisponibilidad(rowData)} icon="delete" fontSize={30} color="red" />
            </div>)
        }
        </div>
    },
  ]);

  const [encabezadoTarifario] = useState([
    { title: 'Mes', field: 'mes.descripcion'},
    { title: 'Valor', field: 'valorDeTarifa'},
    { title: 'Acción', field: 'accion',
    render: rowData=><div style={{minWidth: '100px'}}>
        {
            (<div>
                <TooltipPersonalizado title="Editar valor de tarifa" handleFunction={() => editarValorTarifario(rowData)} icon="edit" fontSize={30} color="primary" />
            </div>)
        }
        </div>
    },
  ]);

  // eliminar la disponibilidad
  const eliminarDisponibilidad = ({fechaInicio, fechaFin, id}) => {
    idDisponibilidad = id;
    setAlertaDeConfirmacion(true)
    setDatosDisponibilidad(`${functions.FormatearFecha(fechaInicio || "")} A ${functions.FormatearFecha(fechaFin || "")}`)
  }

  const cerrarAlertaDeConfirmacion = () => setAlertaDeConfirmacion(false);

  const accionDeAlertaDeConfirmacion = async () => {
    setAlertaDeConfirmacion(false);
    setCargandoSolicitud(true);
    changeDataResponse('error', "")

    const controllerMedio = validarTipoDeTarifario();
    const data = { controller: controllerMedio, action: 'eliminar', data: {}, method: "disponibilidad", methodTwo: `${datosGeneralesDelTarifario?.medioDeComunicacion?.id}/${idDisponibilidad}`, tipoMetodo: "DELETE" };
    const respuesta = await dispatch(patchPersonalizadoConDosMetodos(data));
    setCargandoSolicitud(false);
    if(respuesta?.error) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", abrirAlerta: true, });
    setDatosDeRespuesta({ tipoDeAlerta: 'success', mensajeDeAlerta: respuesta?.data || "Registro eliminado correctamente", abrirAlerta: true, });
    const elemento = {medioDeComunicacion: {id: datosGeneralesDelTarifario.medioDeComunicacion?.id }}
    mostrarDetalleDelCanal(elemento)
  }

  const validarTipoDeTarifario = () => {
    switch(tipoDeMedio[tipoDelMedio]) {
        case 1: return tarifarioDeMediosTelevisivos   // Television
        case 2: return tarifarioDeMediosRadiales // Radio
        case 3: return tarifarioDeMediosEscritos; // Escrito
        default: return ""
    }
  }

  // eliminar la tarifario
  const editarValorTarifario = ({mes, valorDeTarifa}) => {
    setEditarTarifario(true)
    setDatosTarifario({id: mes.id, mes: mes.descripcion, valorDeTarifa})
  }
  const cerrarEditarTarifario = () => setEditarTarifario(false);

  const accionTarifaEditada = (respuesta) => {
    setEditarTarifario(false);
    setDatosDeRespuesta({ tipoDeAlerta: 'success', mensajeDeAlerta: respuesta || "Registro eliminado correctamente", abrirAlerta: true, });
    const elemento = {medioDeComunicacion: {id: datosGeneralesDelTarifario.medioDeComunicacion?.id }}
    mostrarDetalleDelCanal(elemento)
  }

  const agregarDisponibilidad = () => setAbrirModalAgregarDisponibilidad(true);
  const cerraModalDisponibilidad = () => setAbrirModalAgregarDisponibilidad(false);

  const accionRegistroGuardado = (respuesta) => {
    setAbrirModalAgregarDisponibilidad(false);
    setDatosDeRespuesta({ tipoDeAlerta: 'success', mensajeDeAlerta: respuesta || "Registro eliminado correctamente", abrirAlerta: true, });
    const elemento = {medioDeComunicacion: {id: datosGeneralesDelTarifario.medioDeComunicacion?.id }}
    mostrarDetalleDelCanal(elemento)
  }

  const cerrarModalPorError = (respuesta) => {
    cerraModalDisponibilidad();
    changeDataResponse('error', `${respuesta?.error?.message}` || "Ocurrió un inconveniente. Intente de nuevo!", true)
  }

  const cerrarRespuesta = (_, reason) => {
    if (reason === 'clickaway') {return}
    changeDataResponse('error', '', false)
  };

  const { canalDeTercero, medioDeComunicacion: {tarifario, disponibilidad} } = datosGeneralesDelTarifario;
  const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, abrirAlerta = false) =>  setDatosDeRespuesta({tipoDeAlerta, mensajeDeAlerta, abrirAlerta});
  const {tipoDeAlerta, mensajeDeAlerta, abrirAlerta} = datosDeRespuesta;

  return (
    <Card className={classes.root}>
        <CardContent>
        {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
        <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={abrirAlerta} handClose={cerrarRespuesta}/>
          <Grid container justify="space-between" alignItems="center" spacing={4} wrap={"wrap"} >
              <Grid item xs={12} md={6}>
                <TituloConIcono title={"Tarifario"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
                <TablaPersonalizada
                    pageSize={10}
                    data={tarifario?.length > 0 ? functions.ordenarArreglo(tarifario, "mes_id") : [] }
                    title={"Listado de tarifario"}
                    header={encabezadoTarifario}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                  <TituloConIcono title={"Disponibilidad"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
                  <TablaPersonalizada
                      pageSize={10}
                      data={disponibilidad?.length > 0 ? functions.ordenarArreglo(disponibilidad, "fechaInicio") : [] }
                      title={"Listado de disponibilidades"}
                      header={encabezadoDisponibilidad}
                      addRegister={agregarDisponibilidad}
                      nameToolTipAdd={"Agregar disponibilidad"}
                  />
              </Grid>
          </Grid>
          {abrirModalAgregarDisponibilidad && (
            <AgregarDisponibilidad
                openFullScreenDialog={abrirModalAgregarDisponibilidad}
                handleClose={cerraModalDisponibilidad}
                title={`Formulario para agregar disponibilidad `}
                medioDeComunicacion={{...datosGeneralesDelTarifario.medioDeComunicacion, canalDeTercero, tipoDelMedio}}
                validarTipoDeTarifario={validarTipoDeTarifario}
                accionRegistroGuardado={accionRegistroGuardado}
                cerrarModalPorError={cerrarModalPorError}
            />
          )}
          {alertaDeConfirmacion && (
            <ModalDeConfirmacion
                title={`¿Está seguro de eliminar el rango de ${datosDisponibilidad || ""}?`} message={"No podrá revertir esta acción"}
                open={alertaDeConfirmacion} closeModal={cerrarAlertaDeConfirmacion} titleButton={"Sí, estoy seguro"}
                actionAdd={accionDeAlertaDeConfirmacion}
            />
          )}
          {editarTarifario && (
            <EditarValorDeLaTarifa
                openFullScreenDialog={editarTarifario}
                handleClose={cerrarEditarTarifario}
                title={`Formulario para editar valor de la tarifa `}
                medioDeComunicacion={{...datosGeneralesDelTarifario.medioDeComunicacion,}}
                datosTarifario={datosTarifario}
                validarTipoDeTarifario={validarTipoDeTarifario}
                accionTarifaEditada={accionTarifaEditada}
            />
          )}
        </CardContent>
    </Card>
  );
}

export default DetalleDelTarifarioYDisponibilidad;